import { useUpdateWindowType, usePageViewEvent } from 'common/hooks';

export const useConfiguratorsListingPage = () => {
	useUpdateWindowType();
	usePageViewEvent();
};
